enum TaskType {
  DIALOG = 1,
  CHAT = 2,
  BOOKING = 3,
  OBSERVATION = 4,
  QUOTE = 5,
  DOSSIER = 6,
  CHECKLIST = 7,
  REPAIR_ORDER = 8,
  GENERAL_DOSSIER = 9,
  FRONT_OFFICE_ALERT = 10,
  INTERNAL_DIALOG = 11,
  NEGATIVE_CUSTOMER_REVIEW = 15,
  KEY_DROP_DOSSIER = 16,
  KEY_DROP_CLIENT = 17,
  WORK_READY = 18,
  CAR_IS_CLEANED = 19,
}

export default TaskType;
